import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ApiService {
  constructor(
    private http: HttpClient
  ) { }

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(path, { params })
      .pipe(catchError(this.formatErrors));
  }

  getCompleteResponse(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(path, { params, observe: 'response' })
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(path, body)
      .pipe(catchError(this.formatErrors));
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(path, body)
      .pipe(catchError(this.formatErrors));
  }

  postCompleteResponse(path: string, body: Object = {}): Observable<any> {
    return this.http.post(path, body, { observe: 'response' })
      .pipe(catchError(this.formatErrors));
  }

  postForAuth(path: string, body: Object = {}): Observable<any> {
    return this.http.post(path, body, { observe: 'response' })
      .pipe(catchError(this.formatErrors));
  }

  putForAuth(path: string, body: Object = {}): Observable<any> {
    return this.http.put(path, body, { observe: 'response' })
      .pipe(catchError(this.formatErrors));
  }

  postForFile(path: string, body: Object = {}): Observable<any> {
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    };
    return this.http.post(path, body, config)
      .pipe(catchError(this.formatErrors));
  }

  delete(path): Observable<any> {
    return this.http.delete(path)
      .pipe(catchError(this.formatErrors));
  }

  postForFileProgress(path: string, body: Object = {}): Observable<HttpEvent<any>> {
    const req = new HttpRequest('POST', path, body, {
      reportProgress: true,
      responseType: 'json',
      headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
    });
    return this.http.request(req);
  }
  postForFileUpload(path: string, body: Object = {}): Observable<any>{
    const config = {
      headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
      observe: 'response' as 'response' // Important to get full response
    };

    return this.http.post(path, body, config)
      .pipe(catchError(this.formatErrors));
  }

  async postUrlEncoded(path: string, body: any) {
    const encodedBody = new URLSearchParams();
    Object.keys(body).forEach(key => {
        encodedBody.append(key, body[key]);
    });

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
        },
        body: encodedBody.toString()
    });

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
}

  
}
